import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.array.for-each";

var sizeFunction = function sizeFunction(scaleLevel, rhythmUnits, breakpoints, typescaleBreakpoints, mediaBreakpoints) {
  var sizeCss = '';
  Object.entries(typescaleBreakpoints).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        breakpointKey = _ref2[0],
        typescale = _ref2[1];

    // Generate CSS Rule
    var rule = "".concat("font-size: ".concat(typescale(scaleLevel), "rem;"), "\n");

    if (rhythmUnits > 0) {
      rule += "line-height: ".concat((breakpoints[breakpointKey].lineHeight * breakpoints[breakpointKey].base * rhythmUnits).toFixed(4), "rem;\n");
    } // Generate responsive CSS


    if (breakpointKey === 'default') {
      sizeCss += rule;
    } else {
      sizeCss += "".concat(mediaBreakpoints[breakpointKey](rule), "\n");
    }
  });
  return sizeCss;
};

var generateSizeMixin = function generateSizeMixin(breakpoints, typescaleBreakpoints, mediaBreakpoints) {
  return function (scaleLevel) {
    var rhythmUnits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return sizeFunction(scaleLevel, rhythmUnits, breakpoints, typescaleBreakpoints, mediaBreakpoints);
  };
};

export { generateSizeMixin };